// removed by extract-text-webpack-plugin
module.exports = {"scroll":"_1EQpB5jq4NTbJ3vLF3OUgh","floating":"_1k2bL-40e0Qr2d1KcVB64Q","grey":"_2HZ83LbOM7hbTcznZo6Mx"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/atoms/BoxScroll/style.css
// module id = 324
// module chunks = 39